import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { FinaliseShipmentInput, FinaliseShipmentResponse } from '../../core/api/lab.types';

/* Create new CryoBox */
export const finaliseShipmentThunk = createAsyncThunk(
  'shipment/finaliseShipment',
  async (values: FinaliseShipmentInput, { rejectWithValue }: any) => {
    const response: FinaliseShipmentResponse = await labApi.finaliseShipment(values);
    if (response.data?.shipManifestedShipment) {
      return response.data?.shipManifestedShipment;
    }
    return rejectWithValue(response.errors);
  },
);
